/**
 * Exceção base para erros de dados
 */
export abstract class DataException extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

/**
 * Exceção para erro de rede
 */
export class NetworkException extends DataException {
  constructor(message: string = 'Network error occurred') {
    super(message);
  }
}

/**
 * Exceção para erro de servidor
 */
export class ServerException extends DataException {
  constructor(message: string = 'Server error occurred') {
    super(message);
  }
}

/**
 * Exceção para erro de cache/storage local
 */
export class CacheException extends DataException {
  constructor(message: string = 'Cache error occurred') {
    super(message);
  }
}

/**
 * Exceção para erro de autenticação
 */
export class AuthException extends DataException {
  constructor(message: string = 'Authentication error occurred') {
    super(message);
  }
}

/**
 * Exceção para token inválido
 */
export class InvalidTokenException extends AuthException {
  constructor(message: string = 'Token is invalid or expired') {
    super(message);
  }
}
